require('./contractEasyLoanView.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require("react-router-dom");
//@actions
const blockedAccountsActions = require('actions/blockedAccounts');
const contractEasyLoan = require('../../actions/contractEasyLoan');
const segmentedLoanActions = require('../../actions/segmentedLoanProducts');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { CallMeBack } = require('components/callMeBack/callMeBack');
//@core
const { formatText, getFinalTitle } = require('core/i18n').i18n;
//@components
const ContractEasyLoan = require('../../components/contracts/contractEasyLoan/contractEasyLoan');
const ContractEasyLoanError = require('../../components/contracts/contractEasyLoan/contractEasyLoanErrorStep/contractEasyLoanErrorStep');
const ContractEasyLoanErrorAsnef = require('../../components/contracts/contractAsnefError/contractAsnefError');
const ContractEasyLoanSidebar = require('../../components/contracts/contractEasyLoan/contractEasyLoanSidebar/contractEasyLoanSidebar');
const ContractEasyLoanSuccess = require('../../components/contracts/contractEasyLoan/contractEasyLoanSuccessStep/contractEasyLoanSuccessStep');
// @ CC Components
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');

//@constants
const { WIZARD_FIRST_STEP } = require('constants/index');
//@utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { recordLinkV2 } = require("utilities/tagging");
const {
    EASY_LOAN_WAFFER,
    NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require( '../../components/contracts/contractAresLoan/analytics/contractAresLoanAnalytics' );

class ContractEasyLoanView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayLeaveModal: false
        };

        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.onHandleSelectedAccount = this.onHandleSelectedAccount.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.leaveModalIsReady = this.leaveModalIsReady.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures } = this.props;

        if(!immFlagBasedFeatures.get(EASY_LOAN_WAFFER)){
            window.location.href = "/myprofile/loans-mortgages/";
        }

        // Position in the top of page after load
        scrollToTop();
    }

    componentDidUpdate() {
        if (this.props.immContractEasyLoan.get('notAvailable')) {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;
        this.setState({
            displayLeaveModal: true
        });
        this.props.segmentedLoanProductsReset();
        resetBlockedAccounts();
    }

    onHandleSelectedAccount(accountId) {
        const { setSelectedAccount } = this.props;
        setSelectedAccount({ accountId });
    }

    setVisibleStep(visibleStep) {
        const { setVisibleStep } = this.props;
        setVisibleStep({ visibleStep });
    }

    validateStep(step) {
        const { immFlagBasedFeatures, validateStep } = this.props;
        const newEasyLoanFeatureFlag = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        validateStep({ step });
        this.props.contractEasyLoanValidateStep({ step, newEasyLoanFeatureFlag });
    }

    buildBreadcrum() {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`,
                onLinkClick: () => recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]()),
            },
            {
                text: formatText('contractEasyLoan-breadcrumb')
            }
        ];
    }

    buildContent() {
        const {
            downloadINEDocument,
            downloadPreContractDocument,
            downloanEasyLoanContractDocument,
            formalize,
            getAsnefValidation,
            getBlockedAccounts,
            getHiringDocuments,
            getInstallment,
            immAccounts,
            immContractEasyLoan,
            immFlagBasedFeatures,
            immProfile,
            location,
            onDownloadDocument,
            onPrintDocument,
            preContractualMail,
            requestMinInstallmentQuantity,
            requestProfile,
            resetPrecontractualMail,
            resetStep,
            sendMail,
            setImportMaxMin,
            setLoanAmount,
            setLoanTerm,
            setPaymentDay,
            setPurpose,
            setUpStep,
            setWillCancel,
            toggleAgreeCheckbox,
            toggleINEAgreeCheckbox,
            getINEDocument,
            getEasyLoanPolicyDocument,
            setOfficeStep,
            setInitApiFlag,
            onAgreeReset,
            officePrintReset,
            getLoanContractDocuments,
            sendEasyLoanSimpleEmail,
            resetMailSent,
            handleScrolldownPolicy
        } = this.props;

        const error = immContractEasyLoan.get('error');
        const isEasyLoanEmailInitError = immContractEasyLoan.get('isEasyLoanEmailInitError')
        const errorAsnef = immContractEasyLoan.get('errorAsnef');
        const success = immContractEasyLoan.get('submitSuccessful');
        const openingCommission = immContractEasyLoan.getIn(['openingCommission', 'amount']);
        const tin = immContractEasyLoan.get('tin');

        const selectedAccount = immContractEasyLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const loanTotalImport = immContractEasyLoan.get("totalAmount");

        let content;
        if (error || isEasyLoanEmailInitError) {
            content = this.buildError();
        } else if (errorAsnef) {
            content = this.buildErrorAsnef(immContractEasyLoan);
        } else if (success) {
            content = this.buildSuccess(
                immContractEasyLoan,
                immAccount,
                PersonalDataHelper.getEmail(immProfile)
            );
        } else if (immContractEasyLoan.get('stepReady') && !error && !errorAsnef) {
            let sidebar;
            sidebar = (
                <ContractEasyLoanSidebar
                    loanTotalImport={loanTotalImport}
                    immAccount={immAccount}
                    immContractEasyLoan={immContractEasyLoan}
                    openingCommission={openingCommission}
                    tin={tin}
                    location={location}
                />
            );
            
            content = (
                <div>
                    <PreLeaveModalComponent
                        acceptText={formatText('contractEasyLoan-leaveModalQuit')}
                        cancelText={formatText('contractEasyLoan-leaveModalStayHere')}
                        confirmationMessage={formatText('contractEasyLoan-leaveModalMessage')}
                        confirmationTitle={formatText('contractEasyLoan-leaveModalTitle')}
                        isReady={this.leaveModalIsReady}
                        onConfirmLeave={this.handleConfirmLeave}
                    />
                    <div className="contract-easy-loan-view__content-data col-xs-8">
                        <ContractEasyLoan
                            downloadINEDocument={downloadINEDocument}
                            downloadPreContractDocument={downloadPreContractDocument}
                            downloanEasyLoanContractDocument={downloanEasyLoanContractDocument}
                            getAsnefValidation={getAsnefValidation}
                            getBlockedAccounts={getBlockedAccounts}
                            getHiringDocuments={getHiringDocuments}
                            getInstallment={getInstallment}
                            immAccounts={immAccounts}
                            immContractEasyLoan={immContractEasyLoan}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onFinish={formalize}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestMinInstallmentQuantity={requestMinInstallmentQuantity}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            resetStep={resetStep}
                            sendMail={sendMail}
                            setImportMaxMin={setImportMaxMin}
                            setLoanAmount={setLoanAmount}
                            setLoanTerm={setLoanTerm}
                            setPaymentDay={setPaymentDay}
                            setPurpose={setPurpose}
                            setSelectedAccount={this.onHandleSelectedAccount}
                            setUpStep={setUpStep}
                            setVisibleStep={this.setVisibleStep}
                            setWillCancel={setWillCancel}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                            validateStep={this.validateStep}
                            getINEDocument={getINEDocument}
                            getEasyLoanPolicyDocument={getEasyLoanPolicyDocument}
                            setOfficeStep={setOfficeStep}
                            setInitApiFlag={setInitApiFlag}
                            onAgreeReset={onAgreeReset}
                            officePrintReset={officePrintReset}
                            getLoanContractDocuments={getLoanContractDocuments}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            resetMailSent={resetMailSent}
                            handleScrolldownPolicy={handleScrolldownPolicy}
                        />
                    </div>
                    <div className="col-xs-4">
                        {sidebar}
                        <CallMeBack />
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }

    buildError() {
        const { immGlobalVariables } = this.props;
        const phoneNumber = immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']);

        return (
            <ContractEasyLoanError
                phoneNumber={phoneNumber}
                onLeave={this.props.onLeave}
            />
        );
    }

    buildErrorAsnef(immContractEasyLoan) {
        return (
            <ContractEasyLoanErrorAsnef
                errorValue={immContractEasyLoan.get('selectedAmount')}
                history={this.props.history}
            />
        );
    }

    buildSuccess(immContractEasyLoan, immAccount, email) {
        return (
            <ContractEasyLoanSuccess
                email={email}
                immContractEasyLoan={immContractEasyLoan}
                immAccount={immAccount}
                onLeave={this.props.onLeave}
            />
        );
    }

    goToLoansPage() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    handleConfirmLeave() {
        this.props.onLeave();
    }

    leaveModalIsReady() {
        return false;
    }

    render() {
        const breadcrumb = this.buildBreadcrum();
        const title = formatText('contractEasyLoan-title');
        const content = this.buildContent();

        return (
            <article className="contract-easy-loan-view">
                <OKCover size="medium" section="pg">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle(title)} />
                </OKCover>
                <section className="contract-easy-loan-view__body">
                    {content}
                </section>
            </article>
        );
    }
}

ContractEasyLoanView.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    location: PropTypes.object,
    onDownloadDocument: PropTypes.func.isRequired,
    onLeave: PropTypes.func,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setEasyLoanAccountsInactive: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func,
    setLoanAmount: PropTypes.func,
    setLoanTerm: PropTypes.func,
    setPaymentDay: PropTypes.func,
    setPurpose: PropTypes.func,
    setSelectedAccount: PropTypes.func.isRequired,
    setUpStep: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    toggleINEAgreeCheckbox: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    contractEasyLoanValidateStep:PropTypes.func.isRequired,
    getEasyLoanPolicyDocument: PropTypes.func.isRequired,
    setOfficeStep: PropTypes.func,
    setInitApiFlag: PropTypes.func,
    onAgreeReset: PropTypes.func,
    officePrintReset: PropTypes.func,
    getLoanContractDocuments: PropTypes.func,
    sendEasyLoanSimpleEmail: PropTypes.func,
    resetMailSent: PropTypes.func
};

ContractEasyLoanView.defaultProps = {
    immContractEasyLoan: PropTypes.object.isRequired,
    onLeave: () => { },
    setImportMaxMin: () => { },
    setWillCancel: () => { }
};

module.exports.constructor = ContractEasyLoanView;
module.exports = withRouter(connect(
    state => ({
        immAccounts: state.accounts,
        immContractEasyLoan: state.contractEasyLoan,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immProfile: state.profile,
        preContractualMail: state.preContractualMail,
    }), {
    contractLoan: contractEasyLoan.contractLoan,
    downloadINEDocument: contractEasyLoan.downloadINEDocument,
    downloadPreContractDocument: contractEasyLoan.downloadPreContractDocument,
    downloanEasyLoanContractDocument: contractEasyLoan.downloanEasyLoanContractDocument,
    formalize: contractEasyLoan.formalize,
    getAsnefValidation: contractEasyLoan.getAsnefValidation,
    getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
    getHiringDocuments: contractEasyLoan.getHiringDocuments,
    getInstallment: contractEasyLoan.getInstallment,
    getSegmentedLoanProducts: segmentedLoanActions.getSegmentedLoanProducts,
    onDownloadDocument: contractEasyLoan.onDownloadDocument,
    onLeave: contractEasyLoan.simpleActions.contractEasyLoanWillLeave,
    onPrintDocument: contractEasyLoan.onPrintDocument,
    requestMinInstallmentQuantity: contractEasyLoan.requestMinInstallmentQuantity,
    requestProfile: profileActions.requestProfile,
    resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
    resetPrecontractualMail: preContractualMailInfoActions.resetPrecontractualMail,
    resetStep: contractEasyLoan.simpleActions.contractEasyLoanResetStep,
    segmentedLoanProductsReset: segmentedLoanActions.simpleActions.segmentedLoanProductsReset,
    sendMail: preContractualMailInfoActions.sendLoanPreContractualMail,
    setLoanAmount: contractEasyLoan.simpleActions.contractEasyLoanSetLoanAmount,
    setLoanTerm: contractEasyLoan.simpleActions.contractEasyLoanSetTerm,
    setPaymentDay: contractEasyLoan.simpleActions.contractEasyLoanSetPaymentDay,
    setPurpose: contractEasyLoan.simpleActions.contractEasyLoanSetPurpose,
    setSelectedAccount: contractEasyLoan.simpleActions.contractEasyLoanSetAccount,
    setUpStep: contractEasyLoan.setUpStep,
    setVisibleStep: contractEasyLoan.simpleActions.contractEasyLoanSetStep,
    setWillCancel: contractEasyLoan.setWillCancel,
    toggleAgreeCheckbox: contractEasyLoan.simpleActions.contractEasyLoanToggleAgreeCheckbox,
    toggleINEAgreeCheckbox: contractEasyLoan.simpleActions.contractEasyLoanIneToggleAgreeCheckbox,
    onAgreeReset: contractEasyLoan.simpleActions.contractEasyLoanAgreeReset,
    contractEasyLoanValidateStep: contractEasyLoan.simpleActions.contractEasyLoanValidateStep,
    validateStep: contractEasyLoan.validateStep,
    getINEDocument: contractEasyLoan.getEasyLoanINEDocument,
    getEasyLoanPolicyDocument: contractEasyLoan.getEasyLoanPolicyDocument,
    setOfficeStep: contractEasyLoan.setOfficeStep, 
    setInitApiFlag: contractEasyLoan.setInitApiFlag,
    officePrintReset: contractEasyLoan.officePrintReset,
    getLoanContractDocuments: contractEasyLoan.getLoanContractDocuments,
    sendEasyLoanSimpleEmail: contractEasyLoan.sendEasyLoanSimpleEmail,
    resetMailSent: contractEasyLoan.resetMailSent,
    handleScrolldownPolicy: contractEasyLoan.scrolldownPolicy
}
)(ContractEasyLoanView));
